import Flickity from "flickity";

const SELECTORS = {
  component: ".block-ctools .field--name-field-image-carousel.field__items",
};

window.Drupal.behaviors.blockctoolsproductvitrina = {
  attach: (context) => {
    const showcaseInternalPage = context.querySelector(
      ".club--showcase--internal-page"
    );
    if (showcaseInternalPage) {
      const ins = {};
      for (const instance in SELECTORS) {
        let instanceComponent = ins[instance];

        // First Nav
        instanceComponent = [...context.querySelectorAll(SELECTORS[instance])];

        let instanceNotNav = context.querySelector(
          ".field--name-field-image-carousel"
        );

        instanceNotNav.classList.add("carousel", "carousel-main");

        let cloneInstance = instanceComponent[0].cloneNode(true);
        cloneInstance.classList.remove("field--name-field-image-carousel");
        cloneInstance.classList.remove("carousel-main");
        cloneInstance.classList.add("field--name-field-image-carousel-nav");

        const parentBlockInstance = context.querySelector(
          ".block-ctools .content .block-ctools-banner-product-vitrina"
        );
        parentBlockInstance.append(cloneInstance);

        // Second Nav
        const instanceNav = context.querySelector(
          ".field--name-field-image-carousel-nav"
        );

        instanceNav.classList.add("carousel", "carousel-nav");

        if (instanceComponent.length) {
          for (const component of instanceComponent) {
            if (component.children.length > 1) {
              const flickity = new Flickity(component, {
                cellAlign: "center",
                pageDots: true,
                prevNextButtons: true,
                wrapAround: true,
                lazyLoad: true,
                contain: true,
                imagesLoaded: true,
              });
            }
          }
        }

        const instanceFields = context.querySelectorAll(
          ".block-ctools-banner-product-vitrina div.field__item"
        );

        for (let index = 0; index < instanceFields.length; index++) {
          const element = instanceFields[index];
          element.classList.add("carousel-cell");
        }

        function instanceNavSlider() {
          const itenMain = instanceComponent[0].querySelectorAll(
            ".flickity-page-dots .dot"
          );
          const itemField = instanceNav.querySelectorAll(
            ".field__item.carousel-cell"
          );

          for (let indexNav = 0; indexNav < itemField.length; indexNav++) {
            let elementItemField = itemField[indexNav];
            elementItemField.addEventListener("click", function () {
              itemField.forEach((element) => {
                element.classList.remove("is-selected--active");
              });
              elementItemField.classList.add("is-selected--active");
              let indexNavPosition = indexNav;
              itenMain[indexNavPosition].click();
            });
          }

          for (let indexMain = 0; indexMain < itenMain.length; indexMain++) {
            let elementItemMain = itenMain[indexMain];
            elementItemMain.addEventListener("click", function () {
              let itenMainPosition = indexMain;
              const itemFieldDots = context.querySelectorAll(
                ".field--name-field-image-carousel-nav .flickity-page-dots .dot"
              );
              itemFieldDots[itenMainPosition].click();
              itemField.forEach((element) => {
                element.classList.remove("is-selected--active");
              });
              itemField[itenMainPosition].classList.add("is-selected--active");
            });
          }
        }
        instanceNavSlider();
        const flktyNav = new Flickity(instanceNav, {
          draggable: false,
          percentPosition: false,
          groupCells: 1,
          pageDots: true,
          wrapAround: true,
          fullscreen: true,
        });
      }
    }
  },
};
